import moment from "moment";
import { message } from "antd";
import pick from "lodash/pick";
import omit from "lodash/omit";
import get from "lodash/get";
import * as productTypeServices from "../services/productType";
import * as categoryServices from "../services/category";
import { AlignLeftOutlined } from "@ant-design/icons";
// import * as atributeServices from '../services/atribute';
// import * as atributeValueServices from '../services/atributeValue';

const RESOURCE = "productType";
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updated_at) {
    const updatedAt = record.updated_at;
    record.updated_at = moment.unix(updatedAt);
  }

  record.state = record.state === "active" ? true : false;

  if (record.images) {
    record.images =
      record.images && record.images.length > 0
        ? record.images
          .filter((i) => i && i !== "")
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || "",
            status: "done",
            url: i,
          }))
        : "";
  }
  if (record.category_id) {
    record.category_id = [record.category_id];
  }

  if (record.thumbnail && Array.isArray(record.thumbnail)) {
    record.thumbnail =
      record.thumb && record.thumb.length > 0
        ? record.thumb
          .filter((i) => i && i !== "")
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || "",
            status: "done",
            url: i,
          }))
        : [];
  } else if (record.thumbnail && typeof record.thumbnail === "string") {
    record.thumbnail = [
      {
        uid: `${record.id}`,
        name: `${record.name}` || "",
        status: "done",
        url: record.thumbnail,
      },
    ];
  }

  return record;
};

export default {
  namespace: "productType",
  state: {
    data: {
      list: [],
      pagination: {
        anchor: "",
        listAnchor: {
          1: "",
        },
      },
    },
    submitting: false,
    formTitle: "",
    formID: "",
    formVisible: false,
    formData: {},
  },

  effects: {
    *syncKiotViet({ payload, callback }, { call, put }) {
      let success = false;

      const response = yield call(
        productTypeServices.syncKiotViet,
        payload
      );
      callback()
      if (response === null) {
        success = true;
      }
      if (success === false) {
        message.error("Đồng bộ thất bại");
      } else {
        yield put(
          {
            type: "fetch",
            payload: {
              current: 1,
              skip: 0,
              limit: 10,
            }
          }
        )
        message.success("Đồng bộ thành công");
      }

    },
    *checkConnectKiotViet({ payload, callback }, { call, put }) {
      try {
        const response = yield call(
          productTypeServices.checkConnectKiotViet,
          payload
        );
        callback('ok')
      } catch (error) {
        callback('fail')
      }

    },
    *syncOnePartner({ payload, callback }, { call, put }) {
      console.log("syncOnePartner -> payload: ", payload);
      let success = false;
      if (payload.type === "SYNC_ONE_PARTNER") {
        const response = yield call(
          productTypeServices.syncOne,
          payload,
          payload.id,
          payload.partner_id
        );
        console.log("syncOnePartner -> response: ", response);
        if (response === null) {
          success = true;
        }
      }
      if (success === false) {
        message.error("Đồng bộ thất bại");
      } else {
        message.success("Đồng bộ thành công");
      }
    },
    *syncCreateProduct({ payload, callback }, { call, put }) {
      try {
        const response = yield call(productTypeServices.syncCreateProduct, payload);
        if (callback) {
            callback(response)
        }
      }
      catch(err){
        console.log("$$",err)
      }
  
    },
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(productTypeServices.getList, payload);
        if (response) {
          if (response.product_types) {
            list = response.product_types.map((item) => {
              transfromDocument(item);
              return item;
            });
          }

          //list
          yield put({
            type: "save",
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(
                    response,
                    ["anchor"],
                    ""
                  ),
                },
              },
            },
          });
        }
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(list);
      }
    },
    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: "changeFormVisible",
        payload: true,
      });

      yield [
        put({
          type: "saveFormType",
          payload: payload.type,
        }),
        put({
          type: "saveFormID",
          payload: "",
        }),
      ];
      if (payload.type === "A") {
        yield [
          put({
            type: "saveFormTitle",
            payload: "Thêm mới",
          }),
          put({
            type: "saveFormData",
            payload: {
              status: "1",
            },
          }),
        ];
      } else if (payload.type === "E") {
        yield [
          put({
            type: "saveFormTitle",
            payload: `Chỉnh sửa ${payload.id}`,
          }),
          put({
            type: "saveFormID",
            payload: payload.id,
          }),
          put({
            type: "fetchForm",
            payload: {
              id: payload.id,
            },
            callback: (response) => {
              console.log("$$", response);
              if (callback) {
                callback(response);
              }
            },
          }),
        ];
      }

      if (callback) {
        callback();
      }
    },
    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      let listCategory;

      try {
        response = yield call(productTypeServices.get, payload.id, payload);
        listCategory = yield call(categoryServices.getList, {});
        let result = listCategory.categories.filter(
          (item) => item.id === response.category_id
        );
        let parentCategory = listCategory.categories.filter(
          (item) => result[0] && item.id === result[0].parent_id
        );
        let temp = [];
        if (parentCategory[0]) {
          temp.push(parentCategory[0].id);
        }
        temp.push(response.category_id);
        response.category_id = temp;

        if (response) transfromDocument(response);
        yield [
          put({
            type: "saveFormData",
            payload: response,
          }),
        ];
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(response);
      }
    },
    *submit({ payload, callback }, { call, put, select }) {
      yield put({
        type: "changeSubmitting",
        payload: true,
      });

      const params = { ...payload };
      const formType = yield select((state) => state.productType.formType);

      let success = false;
      let response;
      try {
        if (formType === "E") {
          const id = yield select((state) => state.productType.formID);
          if (!params.id) {
            params.id = id;
          }
          response = yield call(productTypeServices.update, id, params);
          success = true;
        } else {
          response = yield call(productTypeServices.create, params);
          success = true;
        }
      } catch (error) {
        success = false;
      }

      yield put({
        type: "changeSubmitting",
        payload: false,
      });

      if (success) {
        message.success("Thành công");
        yield put({
          type: "changeFormVisible",
          payload: false,
        });
      }
      if (callback) {
        callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ["pagination"], {});
      pagi = omit(pagi, ["listAnchor"]);
      const aPagi = get(action.payload, "pagination", {});
      const sPagi = get(state.data, "pagination", {});
      const listAnchor = Object.assign(
        {},
        get(aPagi, "listAnchor", {}),
        get(sPagi, "listAnchor", {})
      );
      const pagination = Object.assign({}, sPagi, { listAnchor }, pagi);
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination,
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
